<div class="coupons-preview"
     [class.device-desktop]="deviceType === 'desktop'"
     [class.device-tablet]="deviceType === 'tablet'"
     [class.device-mobile]="deviceType === 'mobile'">
  <div class="modern-subpage-hero">
  <!-- Header Section -->
  <div class="page-header-zone website-element header-element" 
       *ngIf="isSectionVisible('header')"
       [class.selected]="getHeaderElement()?.selected"
       (click)="onHeaderClick()">
    <app-modern-page-header
      [logo]="getHeaderLogo()"
      [navigation]="getHeaderNavigation()"
      [ctaButton]="getHeaderCTAButton()"
      [visible]="true"
      [clickable]="true"
      [selected]="getHeaderElement()?.selected || false"
      [headingColor]="headingColor"
      [headingFont]="headingFont"
      [backgroundColor]="getHeaderBackgroundColor()"
      (navigationClick)="onNavigationClick($event)">
    </app-modern-page-header>
  </div>

  <!-- Main Content Area -->
  <div class="coupons-main-content">
    <div class="coupons-content-grid">
      <!-- Left Column: Instructions -->
      <section 
        class="instructions-section website-element coupons-instructions-element" 
        *ngIf="isSectionVisible('instructions_section')"
        [class.selected]="getCouponSectionElement()?.selected"
        (click)="onInstructionsSectionClick($event)">
        <div class="instructions-container">
          <div class="instructions-card">
            <h2 class="instructions-title"
                *ngIf="getInstructionHeading()"
                [style.color]="getHeadingColor()"
                [style.font-family]="getHeadingFont()">{{ getInstructionHeading() }}</h2>
            
            <p class="instructions-paragraph"
               *ngIf="getInstructionParagraph()"
               [style.color]="getParagraphColor()"
               [style.font-family]="getBodyFont()">{{ getInstructionParagraph() }}</p>
            
            <div class="steps-list">
              <div class="step-item" *ngFor="let step of getInstructionSteps(); trackBy: trackByIndex">
                <div class="step-number">{{ step.number }}.</div>
                <div class="step-content">
                  <h3 class="step-title"
                      [style.color]="getHeadingColor()"
                      [style.font-family]="getHeadingFont()">{{ step.title }}</h3>
                  <p class="step-description"
                     [style.color]="getParagraphColor()"
                     [style.font-family]="getBodyFont()">
                    {{ step.description }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Right Column: Promo + Coupon -->
      <div class="promo-column">
        <!-- Page Header -->
        <section 
          class="page-header-section website-element coupons-page-header-element" 
          *ngIf="isSectionVisible('page-title')"
          [class.selected]="getCouponSectionElement()?.selected"
          (click)="onPageHeaderSectionClick($event)">
          <div class="page-header-container">
            <h1 class="section-title"
                [style.color]="getHeadingColor()"
                [style.font-family]="getHeadingFont()"
                [ngStyle]="getTitleStyles()">{{ getPageTitle() }}</h1>
            <p class="section-subtitle"
               [style.color]="getParagraphColor()"
               [style.font-family]="getBodyFont()">{{ getPageSubtitle() }}</p>
          </div>
        </section>

        <!-- Coupon Card -->
        <section 
          class="coupon-section website-element coupons-coupon-element" 
          *ngIf="isSectionVisible('coupon_card')"
          [class.selected]="getCouponSectionElement()?.selected"
          (click)="onCouponCardClick($event)">
          <div class="coupon-container">
            <div class="coupon-card">
              <div class="coupon-left" [style.background-color]="getCouponTagColor()">
                <div class="coupon-label">COUPON</div>
              </div>
              <div class="coupon-right">
                <div class="coupon-header">{{ getPromoCodeLabel() }}</div>
                <div class="coupon-code" [style.color]="getCouponTagColor()">{{ getPromoCode() }}</div>
                <div class="coupon-footer">
                  <div class="available-text">{{ getPromoCodeNote() }}</div>
                  <div class="wash-types">
                    <span class="wash-badge" *ngFor="let washType of getWashTypes(); trackBy: trackByIndex">{{ washType }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
  </div>

  <!-- Footer -->
  <div class="website-element footer-element" 
       *ngIf="isSectionVisible('footer')"
       [class.selected]="getFooterElement()?.selected"
       (click)="onFooterClick($event)">
    <app-modern-page-footer 
      [quickLinks]="getFooterQuickLinks()"
      (quickLinkClick)="onNavigationClick($event)"
      [quickLinksTitle]="getFooterQuickLinksTitle()"
      [socialLinks]="getFooterSocialLinks()"
      [socialLinksTitle]="getFooterSocialLinksTitle()"
      [copyright]="getFooterCopyright()"
      [logo]="getFooterLogo()"
      [backgroundColor]="getFooterBackgroundColor()">
    </app-modern-page-footer>
  </div>
</div>
